import { capitalizeFirstLetter } from "app/main/utils/tableUtils";

const yards = {
	urlGET: "api/profile/carriers/:carrierId/yards",
	idKey: "_id",
	listenEvent: ["yardRevision", "profileRevision"],
	segmentKey: "CARRIER_YARDS",
	content: {
		table: {
			variant: "skinny",
			layout: ["name", "city", "state", "type", "coverageRadius", "capacity"],
		},
		pagination: {
			enabled: true,
			resetScroll: true,
		},
		defaults: {
			initial: {
				filters: {
					yard_active: "ACTIVE",
				},
			},
			items: [
				{
					label: "Active",
					description: "Active",
					filters: {
						yard_active: "ACTIVE",
					},
				},
				{
					label: "Archived",
					description: "Archived",
					filters: {
						yard_active: "INACTIVE",
					},
				},
			],
		},
		filters: {
			search: true,
			countVisible: 0,
			items: [
				{
					key: "yard_active",
					type: "select",
					label: "Status",
					defaultValue: "__NOT_SELECTED__",
					options: [
						{
							value: "__NOT_SELECTED__",
							label: "Not Selected",
						},
						{
							label: "Active",
							value: "ACTIVE",
						},
						{
							label: "Archived",
							value: "INACTIVE",
						},
					],
				},
			],
		},
		items: [
			{
				key: "name",
				type: "text",
				label: "Name",
				table: { width: "20%" },
			},
			{
				key: "city",
				type: "text",
				label: "City",
				table: { width: "15%" },
			},
			{
				key: "state",
				type: "text",
				label: "State",
				table: { width: "10%" },
			},
			{
				key: "type",
				type: "text",
				label: "Type",
				table: { width: "15%" },
				builder: (item) => capitalizeFirstLetter(item.type),
			},
			{
				key: "coverageRadius",
				type: "text",
				label: "Radius",
				table: { width: "15%" },
				builder: (item) => `${item.coverageRadius} mi`,
			},
			{
				key: "capacity",
				type: "text",
				label: "Capacity",
				table: { width: "15%" },
				builder: (item) => `${item.currentCapacity}/${item.maxCapacity}`,
			},
			{
				key: "menu",
				type: "menu",
				label: "Menu",
				items: [
					{
						key: "edit",
						label: "Edit",
						auth: ["carrier", "carrier_manager", "carrier_dispatcher", "administrator"],
						dialogBuilder: (item, dataIds) => ({
							viewId: "YARD_VIEW",
							mode: "EDIT",
							dataIds: { ...dataIds, id: item._id, yardId: item._id, mode: "EDIT" },
						}),
					},
					{
						key: "divider",
						variant: "divider",
						auth: ["carrier", "carrier_manager", "carrier_dispatcher", "administrator"],
					},
					{
						key: "activate",
						label: "Activate",
						auth: ["carrier", "carrier_manager", "carrier_dispatcher", "administrator"],
						dialogBuilder: (item, dataIds) => ({
							formId: "YARD_STATUS_FORM",
							mode: "DELETE",
							dataIds: { ...dataIds, id: item._id, status: "active" },
						}),
						isVisible: (item) => !item.active,
					},
					{
						key: "inactivate",
						label: "Archive",
						auth: ["carrier", "carrier_manager", "carrier_dispatcher", "administrator"],
						dialogBuilder: (item, dataIds) => ({
							formId: "YARD_STATUS_FORM",
							mode: "DELETE",
							dataIds: { ...dataIds, id: item._id, status: "inactive", item: item },
						}),
						isVisible: (item) => item.active,
					},
				],
			},
		],
	},
};

export default yards;
